import { render, staticRenderFns } from "./_details.vue?vue&type=template&id=1d3c6919&scoped=true"
import script from "./_details.vue?vue&type=script&lang=js"
export * from "./_details.vue?vue&type=script&lang=js"
import style0 from "./_details.vue?vue&type=style&index=0&id=1d3c6919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3c6919",
  null
  
)

export default component.exports